import { useEffect, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { IVesselOfUser } from "../../pages/LoginPage/constants";
import { loginActions } from "../../pages/LoginPage/reducer";
import { factoryActions } from '../../util/store/factory/reducer';
import { selectViewMode } from '../../util/store/selectors';
import { getStore, useSelector } from "../../util/store/store";
import { OP_STATUS } from '../../util/varibles/constants';
import { IOperation2 } from "../../util/varibles/interface";
import { VIEW_MODE } from "../../util/varibles/permission";
import { SOCKET_FUNC, SOCKET_NAME } from '../../web-socket/constants';
import WSService from '../../web-socket/web-socket-service';
import Operations from "./Operations";
import styles from './style.module.scss';

interface IProps {
    onTracking?(data: IOperation2 | { vessel: IVesselOfUser }): any
    collapsed?: boolean
    onExpand?: () => void
    hideLeftBorder?: boolean
}

const TrackingOp: React.FC<IProps> = (props) => {
    const viewMode = useSelector(selectViewMode);
    const dispatch = useRef(useDispatch());
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1500);

    useEffect(() => {
        const execute = dispatch.current;
        new WSService({
            listener: {
                lev: SOCKET_NAME.TRACKING_OP,
                func: (value) => {
                    switch (value.function) {
                        case SOCKET_FUNC.WEATHER_LIVE:
                            const { vessel_id, weather } = value;
                            execute(loginActions.updateWeather({ vesselId: vessel_id, value: weather || {} }))
                            break;
                        case SOCKET_FUNC.OPERATION_STATUS_CHANGE:
                            const ops = value.message || []
                            if (!Array.isArray(ops))
                                return;

                            const ids = ops.filter(item => item.operation.status === OP_STATUS.PROCESSING).map(item => item.operation.id);
                            if (ids.length === 0)
                                return;

                            const state = getStore();
                            const { vessels } = state.login;
                            const { default_vessel } = state.login.user;
                            const vessel = (vessels || []).find(item => item.vessel_id === default_vessel) || vessels?.[0];
                            if (!vessel)
                                return;
                            const { operations = [] } = vessel;
                            const isExist = ids.every(id => operations.some(item => item.operation.id === id));
                            if (!isExist) {
                                execute(loginActions.getOpsOfVessel())
                            }
                            break;
                        case SOCKET_FUNC.ONGOING_UPDATE: {
                            const { operations = [] } = value.message;
                            execute(loginActions.updateOpsOfVessel(Array.isArray(operations) ? operations || [] : []));
                            break;
                        }
                    }
                }
            }
        })
        execute(factoryActions.gets());
        execute(loginActions.isDashboardEnabled(true))

        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1500);
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            execute(loginActions.isDashboardEnabled(false))
            window.removeEventListener("resize", handleResize);
        }
    }, [])

    if (viewMode !== VIEW_MODE.VESSEL)
        return null;

    return <div
        className={`${styles.page} ${isSmallScreen ? "w-[60%]" : "w-[30%] min-w-[1200px]"}`}
        data-collapsed={props.collapsed}
        data-hide-left-border={props.hideLeftBorder}
    >
        <div className={styles['operations-content']}>
            <Operations onTracking={props.onTracking} />
        </div>
        {props.collapsed && <div className={styles['collapsed-control']}>
            <button type="button" onClick={props.onExpand} aria-label="Show operation control"><b>‹</b></button>
            <span>Operation control panel</span>
        </div>}
    </div>;
}

export default TrackingOp
